import {
  CreateLeadRankConfigInput,
  FindAllLeadRankConfigInput,
  LeadRankConfig,
} from "@yardzen/api-dtos";
import { AxiosError } from "axios";
import { apiClient } from "../base-client";
import { createServerApiClient } from "../server-base-client";

const getApiClient = async (authToken?: string) => {
  if (authToken) {
    return await createServerApiClient(authToken);
  }
  return apiClient;
};

export async function createLeadRankConfig(
  input: CreateLeadRankConfigInput,
  authToken?: string,
): Promise<LeadRankConfig> {
  try {
    const apiClient = await getApiClient(authToken);
    const response = await apiClient.post("lead-rank-config", input);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(`Failed to create LeadRankConfig: ${error.message}`);
    }
    throw error;
  }
}

export async function findOneLeadRankConfig(
  id: string,
  authToken?: string,
): Promise<LeadRankConfig> {
  try {
    const apiClient = await getApiClient(authToken);
    const response = await apiClient.get(`lead-rank-config/${id}`);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      throw new Error(`LeadRankConfig with id ${id} not found`);
    }
    if (error instanceof AxiosError) {
      throw new Error(`Failed to fetch LeadRankConfig: ${error.message}`);
    }
    throw error;
  }
}

export async function findAllLeadRankConfigs(
  input?: FindAllLeadRankConfigInput,
  authToken?: string,
): Promise<LeadRankConfig[]> {
  try {
    const apiClient = await getApiClient(authToken);
    const response = await apiClient.get("lead-rank-config");
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(`Failed to fetch LeadRankConfigs: ${error.message}`);
    }
    throw error;
  }
}

export async function findLatestLeadRankConfig(
  authToken?: string,
): Promise<LeadRankConfig> {
  try {
    const apiClient = await getApiClient(authToken);
    const response = await apiClient.get("lead-rank-config/latest");
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      throw new Error("No LeadRankConfig found");
    }
    if (error instanceof AxiosError) {
      throw new Error(
        `Failed to fetch latest LeadRankConfig: ${error.message}`,
      );
    }
    throw error;
  }
}
